export default __webpack_public_path__ + "static/media/MIT-IBM-logo.66d5df33.png";